<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import { ref, computed,onUnmounted } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import axios from 'axios';
import { authHeader } from '@/helpers/authservice/auth-header';
import Swal from 'sweetalert2';

dayjs.extend(localizedFormat)

onUnmounted(() => {
  order_of_payment.value = null;
  order_of_payment_search_input.value = '';
})

const title = ref('Official Receipt');
const items = ref([
  {
    text: "Home",
  },
    {
    text: "Payment",
  },
  {
    text: "Official Receipt",
    active: true,
  },
]);

const store = useStore();
const loading = computed(() => store.state.globals.loading);
const notification = computed(() => store ? store.state.notification : null);

const order_of_payment = computed({
  get:() => store.state.payment.order_of_payment,
  set:(val) => store.commit('payment/SET_ORDER_OF_PAYMENT',val)
});
const order_of_payment_search_input = computed({
  get:() => store.state.payment.order_of_payment_search_input,
  set:(val) => store.commit('payment/SET_ORDER_OF_PAYMENT_SEARCH_INPUT',val)
});

const getOrderOfPayment = () => store.dispatch('payment/getOrderOfPayment');
store.dispatch('notification/clear', null, { root: true });

const search = async () =>{
  order_of_payment.value = null;
  await getOrderOfPayment();
  order_of_payment_search_input.value = '';
  if(order_of_payment.value){
      amount_input.value = order_of_payment.value.total_penalty_fee;
      or_number_input.value = "";
      await getOrderOfPaymentPdf(order_of_payment.value.id)
  }
}

const pdf_url = ref(null);

const getOrderOfPaymentPdf = async (traffic_record_id) => {
    const {data} = await axios.get(`payment/official_receipt/${traffic_record_id}/preview-pdf`, {
      responseType: "arraybuffer",
      headers: { ...authHeader() }
    });
    const blob = new Blob([data], { type: 'application/pdf' });
    const objectUrl = URL.createObjectURL(blob);
    pdf_url.value = objectUrl;
}

const or_number_input = ref('');
const amount_input = ref(0);

const saveOR = async () =>{
  const confirm = await Swal.fire({
    icon: 'warning',
    title: 'Continue?',
    text: 'Do you want to save this data?',
    showCancelButton: true,
    confirmButtonText: 'Proceed',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });
  store.dispatch('notification/clear', null, { root: true });
  try {
    let inputs = {
      number: or_number_input.value,
      amount: amount_input.value,
      traffic_record_id: order_of_payment.value.id,
    }
    await axios.post(`/payment/official_receipt`,inputs,{
        headers: authHeader()
    })
    order_of_payment_search_input.value = order_of_payment.value.notice_of_violation_number;
    await getOrderOfPayment();
    order_of_payment_search_input.value = null;
    store.dispatch('globals/loaded', null, { root: true });
  } catch (error) {
    if (error.response) {
        const { message } = error.response.data;
        store.dispatch('notification/error', message, { root: true });
    }
    store.dispatch('globals/loaded', null, { root: true });
  }
  

}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <b-alert v-if="notification && notification.message"
              show :variant="notification.type" class="fade show" role="alert">
              {{ notification.message }}
          </b-alert>
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-header">
                  <div class="form-group">
                    <label for="search">Barcode the nov or type the nov # and press enter</label>
                    <input type="text" class="form-control" id="search" autofocus v-model="order_of_payment_search_input" @keyup.enter="search">
                  </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <div class="row" v-if="order_of_payment">
        <div class="col-12">
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-header">
                <table class="table table-bordered table-sm m-0">
                  <tbody>
                    <template v-if="order_of_payment.is_voided == 1">
                      <h1 class="text-center" style="font-weight: bold;"> --VOIDED-- </h1>
                    </template>
                    <template v-else>
                    <tr>
                      <th colspan="2" class="text-center"><h2>{{order_of_payment.notice_of_violation_number ? order_of_payment.notice_of_violation_number : ''}}</h2></th>
                    </tr>
                      <tr>
                        <td style="width:50%;">
                          <table class="table table-bordered table-sm m-0">
                            <tbody>
                              <tr>
                                <th colspan="2" class="text-center">Violation Info</th>
                              </tr>
                              <tr>
                                <td style="width:230px;" class="no-wrap">NOV</td>
                                <td>
                                  <p class="m-0 p-0">{{order_of_payment.notice_of_violation_number ? order_of_payment.notice_of_violation_number : ''}}</p>
                                  <p class="m-0 p-0">
                                    <a href="#" @click.prevent="" data-bs-toggle="modal" data-bs-target="#orderOfPaymentPDF">(Order of Payment)</a> 
                                    
                                    <template v-for="(entry, index) in order_of_payment.violation_penalties" :key="index">
                                      <br>
                                      <a target="_blank" :href="entry.generated_pdf_file_link">
                                        {{order_of_payment.notice_of_violation_number ? (index+1) + "(NOV) - " + order_of_payment.notice_of_violation_number : ''
                                      }}
                                      </a>
                                    </template>

                                  </p>
                                  <p class="m-0 py-2">
                                    <small>Click to view order of payment/nov</small>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td class="no-wrap">OVR</td>
                                <td>{{order_of_payment.ovr.ovr_number ? order_of_payment.ovr.ovr_number : ''}}</td>
                              </tr>
                              <tr>
                                <td class="no-wrap">File Name</td>
                                <td>{{order_of_payment.filename ? order_of_payment.filename : ''}}</td>
                              </tr>
                              <tr>
                                <td class="no-wrap">Violation Date</td>
                                <td>{{order_of_payment.timestamp ? dayjs(order_of_payment.timestamp).format('LL') : ''}}</td>
                              </tr>
                              <tr>
                                <td class="no-wrap">Violation Time</td>
                                <td>{{order_of_payment.timestamp ? dayjs(order_of_payment.timestamp).format('LTS') : ''}}</td>
                              </tr>
                              <tr>
                                <td class="no-wrap">Violation Location</td>
                                <td>{{order_of_payment.violation_information.location ? order_of_payment.violation_information.location : ''}}</td>
                              </tr>
                            </tbody>
                          </table>
                          <table class="table table-bordered table-sm m-0 mt-3">
                            <tbody>
                              <tr>
                                <th colspan="2" class="text-center">MVFILE Record</th>
                              </tr>
                              <tr>
                                <td style="width:180px;">Plate #</td>
                                <td>{{order_of_payment.lto_record.plate_number ? order_of_payment.lto_record.plate_number : ''}}</td>
                              </tr>
                              <tr>
                                <td>MV File #</td>
                                <td>{{order_of_payment.lto_record.mv_file_number ? order_of_payment.lto_record.mv_file_number : ''}}</td>
                              </tr>
                              <tr>
                                <td>Series</td>
                                <td>{{order_of_payment.lto_record.series ? order_of_payment.lto_record.series : ''}}</td>
                              </tr>
                              <tr>
                                <td>Year Model</td>
                                <td>{{order_of_payment.lto_record.year_model ? order_of_payment.lto_record.year_model : ''}}</td>
                              </tr>
                              <tr>
                                <td>Classification</td>
                                <td>{{order_of_payment.lto_record.classification ? order_of_payment.lto_record.classification : ''}}</td>
                              </tr>
                              <tr>
                                <td>Body Type</td>
                                <td>{{order_of_payment.lto_record.body_type ? order_of_payment.lto_record.body_type : ''}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td>
                          <table class="table table-bordered table-sm m-0">
                            <tbody>
                              <tr>
                                <th colspan="2" class="text-center">Violations</th>
                              </tr>
                              <template v-for="(entry, index) in order_of_payment.violations" :key="index">
                                <tr>
                                  <td>
                                    {{entry.name ? entry.name : ''}}
                                  </td>
                                  <td style="width:80px;">
                                    {{entry.penalty_fee ? entry.penalty_fee : 0}}
                                  </td>
                                </tr>
                              </template>
                              <tr>
                                <td>
                                  <b>Total</b>
                                </td>
                                <td>
                                  <b>{{order_of_payment.total_penalty_fee}}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <table class="table table-bordered table-sm m-0 mt-2">
                            <tbody>
                              <tr>
                                <th colspan="2" class="text-center">Payment</th>
                              </tr>
                              <template v-if="order_of_payment.or_number">
                                <tr>
                                  <td style="width:50%">OR #</td>
                                  <td>{{order_of_payment.or_number}}</td>
                                </tr>
                                <tr>
                                  <td>Paid Amount</td>
                                  <td>{{order_of_payment.amount}}</td>
                                </tr>
                                <tr>
                                  <td>Payment Date</td>
                                  <td>{{dayjs(order_of_payment.payment_date).format('LLL')}}</td>
                                </tr>
                                <tr>
                                  <td colspan="2" class="text-center"><h1 class="text-success" style="font-weight: bold;"> --PAID-- </h1></td>
                                </tr>
                              </template>
                              <template v-if="!order_of_payment.or_number">
                                <tr>
                                  <td class="text-center">
                                    Status: 
                                    <span  class="text-danger">Unpaid</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <form @submit.prevent="saveOR">
                                      <div class="row">
                                          <div class="col-md-12 col-xl-6">
                                            <label for="or_no">OR #</label>
                                            <input type="text" required class="form-control" id="or_no" v-model="or_number_input">
                                          </div>
                                          <div class="col-md-12 col-xl-6">
                                            <label for="amount">Amount</label>
                                            <input type="number" required class="form-control" id="amount" v-model="amount_input">
                                          </div>
                                          <div class="col-12 mt-1" style="text-align: right;">
                                            <button type="submit" class="btn btn-primary">Save OR</button>
                                          </div>
                                      </div>
                                    </form>
                                  </td>
                                </tr>
                              </template>
                              
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>

  <div class="modal fade" role="dialog" id="orderOfPaymentPDF" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
              <b-overlay :show="loading">
                <div class="modal-header">
                    <h5 class="modal-title">Order of Payment</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <iframe type="application/pdf" :src="pdf_url" style="width: 100%;height: 800px;"></iframe>
                </div>
              </b-overlay>
          </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

</style>
